import AutoNumeric from "autonumeric";

export default {
  init(selector) {
    const autoNumericOptions = {
      digitGroupSeparator: ",",
      decimalCharacter: ".",
      decimalCharacterAlternative: ",",
      outputFormat: "number",
    };

    let elements = document.querySelectorAll(selector);
    elements.forEach((item) => {
      const elementId = item.id;
      new AutoNumeric(`#${elementId}`, autoNumericOptions);
    });
  },
};
